/* eslint-disable */
import {get, post} from '../service/fetch';

const env = process.env.BASE_API;
/*
 * 运单号分流接口
 */
export const xiaoIStore = (waybillNo) => get(`${env}/xiaoI/store`, {wayBillNo: waybillNo});
/**
 * C5电话分流服务接口
 * @param mobile
 */
export const serchByMobile = (mobile) => get(`${env}/c5Api/serchByMobile`, {mobile: mobile});

/**
 * 机器人聊天
 * @param data
 * @returns {*}
 */
export const xiaoIChat = (data) => post(`${env}/xiaoI/chat`, data);

/**
 * 创建会话
 * @param data
 * @returns {*}
 */
export const sessionCreate = (data) => post(`${env}/auth`, data);

/**
 * 拉取消息数据
 * @param data
 * @returns {*}
 */
// export const pullMessage = (data) => post(`${env}/message/pull', data);

/**
 * 会话状态发送图片消息
 * @param data
 * @returns {*}
 */
export const postImgMessage = (data) => post(`${env}/message/post/image`, data);

/**
 *  会话状态发送文本消息
 * @param data
 * @returns {*}
 */
// export const postMessage = (data) => post(`${env}/message/post', data);

/**
 * 判断是否在会话
 * @param data
 * @returns {*}
 */
export const getSession = (data) => post(`${env}/session/get`, data);

/**
 * 缓存历史记录
 * @param data
 * @returns {*}
 */
export const getHistoryMsg = (data) => post(`${env}/message/historyMsg`, data);

/**
 * 缓存客户历史记录
 * @param data
 * @returns {*}
 */
export const cacheHistory = (data) => post(`${env}/message/cacheHistory`, data);

/**
 * 获取验证码Id
 * @param data
 * @returns {*}
 */
export const getCaptchaId = (data) => post(`${env}/captcha/getId`, data);
/**
 * 获取验证码图片流接口.
 * @param data
 * @returns {*}
 */
export const getCaptchaPictureFlow = (data) => post(`${env}/captcha/getPictureFlow`, data);
/**
 * 验证验证码
 * @param data
 * @returns {*}
 */
export const verifyCaptcha = (data) => post(`${env}/captcha/verify`, data);




/**
 * 获取快速渠道link
 * @param data
 * @returns {*}
 */
export const getLink = (data) => post(`${env}/v1/online/fastTrackEntrance/getLink`, data);
/**
 * 小I机器人服务
 * @param data
 * @returns {*}
 */
export const xiaoChat = (data) => post(`${env}/v1/online/robot/chat`, data);
/**
 * 查询会话状态
 * @param data
 * @returns {*}
 */
export const getStatus = (data) => post(`${env}/v1/online/session/getStatus`, data);

/**
 * 获取我寄的运单列表
 * @param data
 * @returns {*}
 */
export const getMySendList = (data) => post(`${env}/v1/online/order/senderlist`, data);

/**
 * 获取我收的运单列表
 * @param data
 * @returns {*}
 */
export const getMyReceiveList = (data) => post(`${env}/v1/online/order/receiverlist`, data);

/**
 * 发送消息
 * @param data
 * @returns {*}
 */
export const postMessage = (data) => post(`${env}/v1/online/message/post`, data);

/**
 * 接收消息
 * @param data
 * @returns {*}
 */
export const pullMessage = (data) => post(`${env}/v1/online/message/pull`, data);

/**
 * 获取历史消息
 * @param data
 * @returns {*}
 */
export const getHistory = (data) => post(`${env}/v1/online/message/historyMsg`, data);


/**
 * 会话关闭
 * @param data
 * @returns {*}
 */
export const closeSession = (data) => post(`${env}/v1/online/session/close`, data);

/**
 * 会话授权
 * @param data
 * @returns {*}
 */
export const authSession = (data) => post(`${env}/v1/online/auth`, data);

/**
 * 人工追踪
 * @param data
 * @returns {*}
 */
export const trackManual = (data) => post(`${env}/v1/online/manual`, data);

/**
 * 快速通道计数
 * @param data
 * @returns {*}
 */
export const fastTrackEntranceCount = (data) => post(`${env}/v1/online/fastTrackEntrance/count`, data);



// WEBPACK FOOTER //
// ./src/service/service.js